import { render, staticRenderFns } from "./MktPanelPubli.vue?vue&type=template&id=90c8b3f4&scoped=true&"
import script from "./MktPanelPubli.vue?vue&type=script&lang=js&"
export * from "./MktPanelPubli.vue?vue&type=script&lang=js&"
import style0 from "./MktPanelPubli.vue?vue&type=style&index=0&id=90c8b3f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c8b3f4",
  null
  
)

export default component.exports